import EmployeeRatingAndReviewCard from "./EmployeeRatingAndReviewCard";

export default EmployeeRatingAndReviewCard;
